import { router, Stack } from 'expo-router';
import { Platform } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import BackButton from '@/components/back-button';
import { isDesktop } from '@/core';

export default function ReservationsLayout() {
  const { theme } = useStyles();

  return (
    <Stack>
      <Stack.Screen name="index" options={{ headerShown: false }} />

      <Stack.Screen name="new" options={{ headerShown: false }} />

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="calendar/index"
          options={{
            headerShown: false,
          }}
        />
      ) : null}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="[id]"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="[id]"
          options={({ route }) => ({
            headerTitle: `Rental ID: ${route.params.id}`,
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }

                  router.navigate('/partner/reservations');
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          })}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="subscriptions/[id]"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="subscriptions/[id]"
          options={({ route }) => ({
            headerTitle: `Subscription ID: ${route.params.id}`,
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }

                  router.navigate({
                    pathname: '/partner/reservations',
                    params: { tab: 'subscription' },
                  });
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          })}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="[id]/change-car"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="[id]/change-car"
          options={({ route }) => ({
            headerTitle: 'Change Car',
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }

                  router.navigate(`/partner/reservations/${route.params.id}`);
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          })}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="[id]/cancel"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="[id]/cancel"
          options={({ route }) => ({
            headerTitle: 'Cancel Rental',
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }

                  router.navigate(`/partner/reservations/${route.params.id}`);
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          })}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="[id]/add-incidental"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="[id]/add-incidental"
          options={({ route }) => ({
            headerTitle: 'Add Incidental',
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }

                  router.navigate(`/partner/reservations/${route.params.id}`);
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          })}
        />
      )}
    </Stack>
  );
}
